// extracted by mini-css-extract-plugin
export default {"wrapper":"Gutenberg_wrapper__u72e+"};